import { Feature } from '@ardoq/api-types';
import { featureOperations } from '@ardoq/features';
import { getFeatureContext } from 'streams/featureContext$';

export const hasFeature = (feature: Feature): boolean => {
  return featureOperations.hasFeature(getFeatureContext(), feature);
};
